import { apiService } from '../../../../'
import { UpdatePreferredApplePayRequest } from '../types'

export const consumerApplePayService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    setApplePayPreferred: build.mutation<void, UpdatePreferredApplePayRequest>({
      query: () => {
        return {
          url: '/portal/consumers/account/applepay/preferred',
          method: 'PUT',
        }
      },
      invalidatesTags: (_res, _err, req) => ['ConsumerAccount', ...req.cache.invalidatesTags],
    }),
  }),
})
